import { SinglePaymentParameters, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetPaymentDetails = ({ paymentId }: Pick<SinglePaymentParameters, 'paymentId'>) =>
    useRepositoryQuery('paymentDetails', 'get', { paymentId });
